import { Box, Button, CircularProgress, Paper, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useAuthStore } from '../store/auth.store'
import { useUserStore } from '../store/user.store'
import aliveLogo from '../assets/alivelogo.png'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { ERPLoginPageURL } from '../utils/utilities'

const ERPSessionSingin = () => {

    const [loggingIn, setLoggingIn] = useState( false )
    const [failed, setFailed] = useState( false )
    const navigate = useNavigate()

    const AuthStore = useAuthStore()
    const UserStore = useUserStore()

    const { access_token: token } = useParams()
    const [searchParams] = useSearchParams( { module: 'home', redirect: '' } )
    const module = searchParams.get( 'module' )
    const redirect = searchParams.get( 'redirect' )

    const navigateToModule = ( module, role ) => {
        navigate( `/${role}/${module}`, { replace: true } )
    }

    useEffect( () => {
        const loginUser = async () => {
            if ( token ) {
                setLoggingIn( true )
                if ( await AuthStore.doAuthViaERPAuthToken( token ) ) {
                    await UserStore.fetchUser()
                    if ( UserStore.getUser['user_role'] === "STUDENT" ) {
                        if ( redirect ) {
                            const redirectUrl = decodeURIComponent( redirect )
                            return navigate( redirectUrl, { replace: true } )
                        }
                        if ( ['exams', 'assignment', 'material', 'discussions', 'resume-builder'].includes( module ) )
                            navigateToModule( module, 'student' )
                        else
                            navigate( '/student/home', { replace: true } )
                    } else {
                        if ( redirect ) {
                            const redirectUrl = decodeURIComponent( redirect )
                            return navigate( redirectUrl, { replace: true } )
                        }
                        if ( ['exams', 'assignment', 'material', 'questionbank', 'quizzes', 'discussions'].includes( module ) )
                            navigateToModule( module, 'faculty' )
                        else
                            navigate( '/faculty/home', { replace: true } )
                    }
                    setFailed( false )
                    setLoggingIn( true )
                } else {
                    setLoggingIn( false )
                    setFailed( true )
                }
            } else {
                navigate( `/`, { replace: true } )
            }
        }
        loginUser()
        // eslint-disable-next-line
    }, [UserStore, AuthStore, token, navigate] )

    return (
        <Box display="flex" position="relative" height="100%" alignItems="center" width="100%" justifyContent="center" flexWrap="wrap" sx={{ overflowX: "hidden", backgroundImage: "url('/imgs/bg-pattern1.png')", backgroundRepeat: "repeat" }}>
            <Box sx={{ borderRadius: "5px", zIndex: 5, background: "rgba(0,0,0,0.7)", position: "absolute", top: 0, right: 0, bottom: 0, left: 0 }}></Box>
            {loggingIn && <Paper sx={{ padding: "20px", display: "flex", flexDirection: "column", gap: "10px", alignItems: "center", zIndex: 10, position: "relative" }}>
                <img width="50px" src={aliveLogo} alt="Alive Logo" />
                <Typography display="flex" alignItems="center" color="GrayText" gap="10px" variant="subtitle2">
                    <CircularProgress size={20} />
                    Authenticating
                </Typography>
            </Paper>}
            {failed && <Paper sx={{ padding: "20px", display: "flex", flexDirection: "column", gap: "10px", alignItems: "center", zIndex: 10, position: "relative" }}>
                <img width="50px" src={aliveLogo} alt="Alive Logo" />
                <Typography display="flex" flexDirection="column" alignItems="center" color="GrayText" gap="10px" variant="subtitle2">
                    Failed to login in Alive Digital classrooms!
                    {/* <small>Please try to refresh again</small> */}
                    <Button sx={{ textTransform: "capitalize" }} color="error" variant="outlined" onClick={() => window.location.href = ERPLoginPageURL} >Back to ERP</Button>
                </Typography>
            </Paper>}
        </Box >

    )
}

export default ERPSessionSingin
